<script setup>
const props = defineProps({
  currentIndex: {
    type: Number,
    default: 0,
  },
});

const right_nav_button = ref(null);
const left_nav_button = ref(null);
const right_nav_button_image_src = ref("images/arrow-right.svg");
const left_nav_button_image_src = ref("images/arrow-left-gray.svg");

function getNavIcon() {
  if (
    right_nav_button.value?.$el.classList.contains("swiper-button-disabled")
  ) {
    right_nav_button_image_src.value = "images/arrow-right-gray.svg";
  } else {
    right_nav_button_image_src.value = "images/arrow-right.svg";
  }
  if (left_nav_button.value?.$el.classList.contains("swiper-button-disabled")) {
    left_nav_button_image_src.value = "images/arrow-left-gray.svg";
  } else {
    left_nav_button_image_src.value = "images/arrow-left.svg";
  }
}

watch(
  () => props.currentIndex,
  (value) => {
    getNavIcon();
  }
);
</script>

<template>
  <div>
    <div class="absolute right-0 z-10 top-1/2 transform -translate-y-1/2">
      <nuxt-img
        ref="right_nav_button"
        :src="right_nav_button_image_src"
        class="w-2.5 cursor-pointer swiper-navigation-next"
        format="webp"
      />
    </div>
    <div class="absolute left-0 z-10 top-1/2 transform -translate-y-1/2">
      <nuxt-img
        ref="left_nav_button"
        :src="left_nav_button_image_src"
        class="w-2.5 cursor-pointer swiper-navigation-prev"
        format="webp"
      />
    </div>
  </div>
</template>
